import React from "react";
import CalculatorForm from "./CalculatorForm";

export default function ArKalkulatorModalContent() {
  return <CalculatorForm />;
}
